import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInstance";
import { Button } from "@mui/material";

const GoogleLoginButton = () => {
  const navigate = useNavigate();

  const SendNewUserEmail = async (email) => {
    try {
      if (!email) {
        console.warn("Email is required to send email.");
        return;
      }


      const response = await axiosInstance.post(
        apiEndPointsConfig.sendNewUserDetailsEmail,
        { phoneNumber: email }
      );

      if (response.data.success) {
        console.log("New user email sent successfully.");
      } else {
        console.warn("Failed to send new user email:", response.data.message);
      }
    } catch (error) {
      console.error("Error sending new user email:", error.message);
    }
  };

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        const userInfo = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${response.access_token}`,
            },
          }
        );

        const res = await axiosInstance.post(apiEndPointsConfig.loginWithGoogle, {
          email: userInfo.data.email,
          country: "",
          dropoff: "login",
        });

        localStorage.setItem("token", res.data.token);
        localStorage.setItem("emailNo", res.data.user.email);
        localStorage.setItem("userId", res.data.user._id);
        localStorage.setItem("userRole", res.data.user.role);

        if (res.data.isNew === false) {
          navigate("/dashboard");
        } else {
          navigate("/form");
          SendNewUserEmail(res.data.user.email);
        }
      } catch (err) {
        console.error("Login failed:", err);
        alert("Login failed. Please try again.");
      }
    },
    onError: () => {
      console.error("Google Login Failed");
      alert("Login failed. Please try again.");
    },
  });

  return (
    <Button
      fullWidth
      onClick={() => login()}
      variant="outlined"
      sx={{
        textTransform: "none",
        borderRadius: "8px",
        paddingX: 2,
        paddingY: 1,
        fontWeight: 500,
        fontSize: "16px",
        borderColor: "#4285F4",
        color: "#4285F4",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        "&:hover": {
          borderColor: "#4285F4",
          backgroundColor: "#685ab40f",
        },
      }}
    >
      <img
        src="https://cdn.iconscout.com/icon/free/png-256/free-google-160-189824.png?f=webp&w=128"
        alt="Google icon"
        style={{ width: 20, height: 20 }}
      />
      Continue with Google
    </Button>
  );
};

export default GoogleLoginButton;
